import styles from './WaitingReceiptsAlert.module.css'

// Receipts Control is holding because the picker's tag names a sign-in nobody
// here is yet: they clocked on for the first time with no signal, and had no
// induction before it. GET /api/dashboard, as waiting_tag_receipts (API
// services/god-dashboard.js waitingTagReceipts).
export interface WaitingTagReceipts {
  receipts: number
  pickers: { name: string; receipts: number; last_at: string }[]
}

// The most pickers named before "and N more".
const SHOWN = 6

export function WaitingReceiptsAlert({ waiting }: { waiting: WaitingTagReceipts | null | undefined }) {
  if (!waiting || !waiting.receipts) return null
  const shown = waiting.pickers.slice(0, SHOWN)
  const more = waiting.pickers.length - shown.length
  const one = waiting.pickers.length === 1
  return (
    <div className={styles.alert} role="alert" data-testid="waiting-receipts">
      <p className={styles.message}>
        {waiting.receipts === 1 ? '1 receipt is' : `${waiting.receipts} receipts are`} not counted yet: {one ? 'this picker' : 'these pickers'}{' '}
        clocked on for the first time with no signal, so Control doesn’t know them yet.
      </p>
      <p className={styles.detail}>
        <span className={styles.names}>
          {shown.map((p) => `${p.name} (${p.receipts})`).join(', ')}
          {more > 0 ? ` and ${more} more` : ''}
        </span>
      </p>
      <p className={styles.detail}>
        Ask {one ? 'them' : 'each of them'} to open the Crew app somewhere with signal (Wi-Fi or mobile data). Their receipts are kept and are
        counted by themselves as soon as their phone connects. To avoid this, have new pickers scan the induction card with signal before
        their first shift.
      </p>
    </div>
  )
}
